import { useEffect, useState } from 'react';
import HeroSectionComponent from './HeroSectionComponent/HeroSectionComponent';
import IntroSectionComponent from './IntroSectionComponent/IntroSectionComponent';
import MeetOrbiinComponent from './MeetOrbiinComponent/MeetOrbiinComponent';
import NavbarComponent from './NavbarComponent/NavbarComponent';
import PhoneAnimComponent from './PhoneAnimComponent/PhoneAnimComponent';
import TilesComponent from './TilesComponent/TilesComponent';
import UserFlowSectionComponent from './UserFlowSectionComponent/UserFlowSectionComponent';
import VideosComponent from './VideosComponent/VideosComponent';
import R2SectionComponent from './R2SectionComponent/R2SectionComponent';
import BTSSectionComponent from './BTSSectionComponent/BTSSectionComponent';
import DispatcherPanelComponent from './DispatcherPanelComponent/DispatcherPanelComponent';
import ModalPopup from './ModalPopup/ModalPopup';
import EMSRealityBG from './Images/ems-reality-bg.png';
import EMSRealitySlider from './Images/ems-reality-slider.png';
import './baseline.css';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import LoginScreen from './LoginScreen/LoginScreen';
import ScaledCanvas from './responsive/ScaledCanvas';
import { subscribeScroll } from './responsive/scroll';
import usePauseOffscreenVideos from './responsive/usePauseOffscreenVideos';


// Page background: fades in from black at the top and back to black at the bottom.
// Runs in the shared scroll loop and writes a CSS variable directly, so scrolling
// no longer re-renders the whole page.
const FADE_DISTANCE = 400; // design px

const usePageFade = () => {
  useEffect(() => {
    let lastPage = null;
    let lastFooter = null;
    const setColor = (name, v) => document.documentElement.style.setProperty(name, `rgb(${v}, ${v}, ${v})`);
    return subscribeScroll((y, vh) => {
      const scale = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--site-scale')) || 1;
      const fade = FADE_DISTANCE * scale;
      const fromBottom = document.documentElement.scrollHeight - vh - y;
      const topV = y < fade ? Math.round(255 * Math.max(0, y) / fade) : 255;
      const bottomV = fromBottom < fade ? Math.round(255 * Math.max(0, fromBottom) / fade) : 255;
      const pageV = scale === 1 ? (y < fade ? topV : bottomV) : topV;
      if (pageV !== lastPage) { lastPage = pageV; setColor('--scroll-color', pageV); }
      if (bottomV !== lastFooter) { lastFooter = bottomV; setColor('--footer-color', bottomV); }
    });
  }, []);
};

function App() {
  const [showModal, toggleModal] = useState(false);

  usePageFade();
  usePauseOffscreenVideos();

  const handleModalClick = () => {
    toggleModal(!showModal)
  }

  return (
    <div className="main">
    {showModal && (
      <div className="modal">
        <ModalPopup handleModalClick={handleModalClick}/>
      </div>
    )}
      <NavbarComponent modalClick={handleModalClick} />
      <ScaledCanvas>
      <HeroSectionComponent />
      <TilesComponent />
      <IntroSectionComponent />
      <MeetOrbiinComponent />
      <PhoneAnimComponent />
      <UserFlowSectionComponent />
      <div className="blurb begins-with-size-edit">
        Begins with a quick account setup. <br/>
        Built around millions of journeys. <br/>
        From morning commutes to late-night drives.
      </div>
      <VideosComponent />
      <div className="reality-box">
        <img src={EMSRealityBG} id="ems-reality-bg" alt="Grey background with title"/>
        <div className="ems-horizontal-slider">
          <img src={EMSRealitySlider} id="ems-reality-img" alt="Statistic graphic"/>
        </div>
      </div>
      <R2SectionComponent modalClick={handleModalClick} />
      <DispatcherPanelComponent />
      <BTSSectionComponent />
      </ScaledCanvas>
    </div>
  );
}

function AuthGate() {
  const { authStatus } = useAuthenticator((ctx) => [ctx.authStatus]);
  if (authStatus === 'configuring') return null;
  return authStatus === 'authenticated' ? <App /> : <LoginScreen />;
}

export default function AuthenticatedApp() {
  return (
    <Authenticator.Provider>
      <AuthGate />
    </Authenticator.Provider>
  );
}
